import { useKnowledgeStore } from '@/stores/knowledge';

export function SourceLineage() {
  const { selectedCanonical } = useKnowledgeStore();

  if (!selectedCanonical) return null;

  const sourceIds = selectedCanonical.source_entity_ids || [];

  if (sourceIds.length === 0) {
    return <div className="text-sm text-slate-400">No source lineage available.</div>;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-slate-700">
        Source Concepts ({sourceIds.length})
      </h3>
      <p className="text-xs text-slate-400">
        These raw knowledge concepts were merged to create this canonical entity.
      </p>
      <div className="space-y-1.5">
        {sourceIds.map((id, i) => (
          <div
            key={id}
            className="flex items-center gap-3 px-3 py-2 bg-white rounded-lg border border-slate-200 text-sm"
          >
            <span className="text-slate-400 text-xs w-6 text-right shrink-0">{i + 1}.</span>
            <span className="font-mono text-xs text-slate-600 truncate flex-1">{id}</span>
            <span className="text-xs text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full shrink-0">Firestore</span>
          </div>
        ))}
      </div>
    </div>
  );
}
